import { TextAreaProps } from '../interface/interface';

const TextAreaWithLimit = ({
  maxLength,
  text,
  onTextChange,
  className,
}: TextAreaProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onTextChange(e.target.value);
  };

  return (
    <div>
      <textarea
        value={text}
        onChange={handleChange}
        maxLength={maxLength}
        className={`w-full border border-primary-blue-500 rounded-md resize-none text-sm px-4 py-3 h-36 focus:shadow-none outline-none focus:ring-0 focus:border-primary-blue-500 ${className}`}
      />
      <p className="text-xs mt-1 font-regular ">
        {maxLength - text.length} characters left
      </p>
    </div>
  );
};

export default TextAreaWithLimit;
